import React from 'react';

export const ArrowBackIcon = ({style, ...props}: React.SVGProps<SVGSVGElement>) => 
{
	return (
		<svg 
			viewBox="0 -960 960 960" 
			style={{
				width: 16,
				height: 16,
				fill: 'currentColor',
				...style
			}} 
			{...props}
		>
			<path d='m393-416 178 179-91 91-334-334 334-334 92 91-179 179h421v128H393Z'/>
		</svg>
	);
};